import axios from 'axios';
import ServerProperties from '../config/server.js'

export default {
  ReadRequest: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get( 
      ServerProperties.ATM_CLOUD.API+'Maintenance/Request/?' + params.data.order + '&' + params.data.filter + '&page=' + params.data.page,
      params.data
    )
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
        params.onfailed(error)
    });
  },
  ReadReport: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get( 
      ServerProperties.ATM_CLOUD.API+'Maintenance/Report/?type=' + params.data.status+ '&' + params.data.order + '&' + params.data.filter + '&page=' + params.data.page,
      params.data
    )
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
        params.onfailed(error)
    });
  },
  Report: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.put( 
      ServerProperties.ATM_CLOUD.API + 'Maintenance/Report/Execute/' + params.data.alias + '/'
    )
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
        params.onfailed(error)
    });
  },
  RegisterRequest: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.post( 
      ServerProperties.ATM_CLOUD.API + 'Maintenance/Work/RegisterRequest/',
      params.data.field
    )
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
        params.onfailed(error)
    });
  },
  RejectRequest: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.patch( 
      ServerProperties.ATM_CLOUD.API + 'Maintenance/Request/' + params.data.Asset + '/Reject/' + params.data.Alias + '/'
    )
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
        params.onfailed(error)
    });
  },
  RejectReport: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.patch( 
      ServerProperties.ATM_CLOUD.API + 'Maintenance/Report/Reject/' + params.data.Alias + '/'
    )
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
        params.onfailed(error)
    });
  },
}


// WEBPACK FOOTER //
// ./src/App/request/model.js